module.exports = __webpack_public_path__ + "static/media/ico_simulation_faceratio.be0004b4.png";